module.exports = __webpack_public_path__ + "static/img/Audience_Matters_Target.b89f24c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/targetImages/Audience_Matters_Target.png
// module id = 1599
// module chunks = 0